export const DEFAULT_DATA = [];
